import { API, APIObject } from '@/shared/plugins/Api/API'
import { ProjectQuotas } from '@/shared/plugins/Api/QUOTA-MANAGER/ProjectQuotas'

class AvailableQuotas {
  constructor (options) {
    this['fpu-s'] = options['fpu-s'] || 0
    this.projects = options.projects || 0
  }
}

class OrganizationQuotas extends APIObject {
  constructor (options) {
    super('QUOTA_MANAGER', options, true)
    this.created_at = this.created_at || null
    this.updated_at = this.updated_at || null
    this.updated_by = this.updated_by || null
    this.organization_id = this.organization_id || null
    this.projects_quotas = this.projects_quotas ? this.projects_quotas.map(project => new ProjectQuotas(project)) : []
  }

  async save () {
    return super.save({
      method: 'PUT',
      url: 'v1/organizations'
    })
  }
}

class OrganizationsQuotas extends API {
  constructor (ID) {
    super(ID, true)
  }

  async list (full = true) {
    const data = await this.request({
      method: 'GET',
      url: 'v1/organizations',
      params: { full }
    })
    return new OrganizationQuotas(data)
  }

  async available () {
    const data = await this.request({
      method: 'GET',
      url: 'v1/organizations/available'
    })
    return new AvailableQuotas(data)
  }
}

export default OrganizationsQuotas
export {
  OrganizationQuotas,
  OrganizationsQuotas
}
